import { render, staticRenderFns } from "./AwardLetter.vue?vue&type=template&id=90824844"
import script from "./AwardLetter.vue?vue&type=script&lang=js"
export * from "./AwardLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports